import { useMutation } from "@tanstack/react-query";
import {
  addItemToCollection,
  deleteItemFromCollection,
} from "directus/src/operations";
import { toast } from "sonner";
import { invalidateAllQueries } from "utils/utils";

export function useCreatePerformanceReview({ onSuccess }) {
  return useMutation({
    mutationFn: async ({ quadrimester, revieweeId, reviewerId, payload }) => {
      const data = {
        quadrimester,
        reviewee: revieweeId,
        reviewer: reviewerId,
        status: "pending",
        ...payload,
      };

      const response = await addItemToCollection("performance_review", data);
      return response;
    },
    onSuccess: (data, variables) => {
      toast.success("Performance review assigned successfully");
      invalidateAllQueries();
      onSuccess?.(data, variables);
    },
    onError: (error) => {
      toast.error(error.message || "Failed to assign performance review");
    },
  });
}

export function useRemovePerformanceReview({ onSuccess }) {
  return useMutation({
    mutationFn: async ({ reviewId }) => {
      const response = await deleteItemFromCollection(
        "performance_review",
        reviewId
      );
      return response;
    },
    onSuccess: (data, variables) => {
      toast.success("Performance review removed successfully");
      invalidateAllQueries();
      onSuccess?.(data, variables);
    },
    onError: (error) => {
      toast.error(error.message || "Failed to remove performance review");
    },
  });
}
